export enum ERunReportStep {
  StartSearch = 'start-search',
  SearchForm = 'search-form',
  SearchResults = 'search-results',
  ConfirmSubjectDetails = 'confirm-subject-details',
  RefineSearch = 'refine-search',
  SubjectForm = 'subject-form',
  CompanyForm = 'company-form',
  AddExtraDetails = 'add-extra-details',
  BehaviorFlags = 'behavior-flags',
  Submit = 'submit',
  ConsentRequired = 'consent-required',
  SearchStarted = 'search-started',
  GeneratingReport = 'generating-report',
}

export enum EReportType {
  AiReport = 'ai_report',
  AiAnalystReport = 'ai_analyst_report',
  AdverseMediaReport = 'adverse_media_report',
}

export enum ESearchType {
  Individual = 'individual',
  Company = 'company',
}

export enum EConsentMethod {
  Upload = 'upload',
  Delegate = 'delegate',
}

export enum ESearchStartedVariant {
  AwaitingConsent = 'awaiting-consent',
  Generating = 'generating',
}

export enum ERefineFilter {
  Employer = 'employer',
  School = 'school',
}

export enum ERunReportQueryParam {
  Q = 'q',
  UseCaseId = 'use-case-id',
  Platform = 'platform',
  ReportType = 'report-type',
  Variant = 'variant',
  Page = 'page',
}
